import React from 'react'
import Logo from '../Images/blue-coast-logo.avif';
import './Header.scss'

const Header = () => {
  const handleBtnClick = () => {
    const contactPopup = document.querySelector('.contact-popup');
    if (contactPopup) {
      if (contactPopup.classList.contains('contact-popup-active')) {
        contactPopup.classList.remove('contact-popup-active');
      }
      else {
        contactPopup.classList.add('contact-popup-active');
      }
    }
  };
  return (
    <div className='header full-width'>
        <div className='header-content main-grid'>
        <a href='./'><img src={Logo} alt='blue coast logo' className='blue-coast-logo'/></a>
        <nav className='header-menu'>
            <ul>
                <li><a href='./#projects' className='menu-link inter-font'>Projects</a></li>
                <li><a href='./#contact' className='menu-link inter-font' onClick={handleBtnClick}>Contact</a></li>
            </ul>
        </nav>
        </div>
    </div>
  )
}

export default Header